import { motion } from "framer-motion";
import { ABOUT_PARAGRAPHS, STATS } from "@/data/content";
import { Reveal, MaskLine, SectionLabel, EASE } from "./Reveal";

const StatCard = ({ stat, i }) => (
  <Reveal delay={i * 0.12} className="group relative bg-[#EFE9DC] border border-[#D8CFBC] p-8 sm:p-10 overflow-hidden" data-testid={`about-stat-card-${i}`}>
    <motion.span
      className="absolute top-0 left-0 h-[2px] bg-[#B8874A]"
      initial={{ width: "0%" }}
      whileInView={{ width: "100%" }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 1.4, delay: 0.3 + i * 0.15, ease: EASE }}
    />
    <p className="font-display text-5xl sm:text-6xl text-[#16302B] tracking-tight">{stat.value}</p>
    <p className="mt-5 text-[15px] leading-relaxed text-[#5C564E] max-w-[16rem]">{stat.label}</p>
    <span className="absolute bottom-6 right-7 font-display italic text-sm text-[#B8874A]">0{i + 1}</span>
  </Reveal>
);

export const About = () => (
  <section id="about" className="relative bg-[#F6F2E8] py-24 sm:py-32 lg:py-40" data-testid="about-section">
    <div className="max-w-[1320px] mx-auto px-5 sm:px-8 lg:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-10">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <Reveal><SectionLabel index="I.">About Sadiya</SectionLabel></Reveal>
            <h2 className="font-display mt-8 text-4xl sm:text-5xl lg:text-[3.4rem] leading-[1.1] tracking-[-0.015em] text-[#221F1B]" data-testid="about-headline">
              <MaskLine inView>Fifteen years of</MaskLine>
              <MaskLine inView delay={0.1}>building, not just</MaskLine>
              <MaskLine inView delay={0.2} className="italic text-[#16302B]">advising.</MaskLine>
            </h2>
          </div>
        </div>
        <div className="lg:col-span-7">
          <Reveal as="blockquote" className="relative font-display italic text-2xl sm:text-3xl leading-[1.45] text-[#16302B] border-l-2 border-[#B8874A] pl-6 sm:pl-8" data-testid="about-pull-quote">
            “Every framework I recommend, I've personally implemented — as an early employee, a business leader, and a founder.”
          </Reveal>
          <div className="mt-12 space-y-6 max-w-2xl">
            {ABOUT_PARAGRAPHS.map((p, i) => (
              <Reveal key={i} delay={i * 0.08} as="p" className="text-base sm:text-[17px] leading-[1.85] text-[#4A453E]">
                {p}
              </Reveal>
            ))}
          </div>
        </div>
      </div>
      <div className="mt-20 lg:mt-28 grid grid-cols-1 md:grid-cols-3 gap-5">
        {STATS.map((s, i) => <StatCard key={s.value} stat={s} i={i} />)}
      </div>
    </div>
  </section>
);
